/**
 * P13 (team feedback fb 31, Pedro 2026-10-10): the email-communication types, one Person
 * flag each (migration 0101). ONE list for every surface — the Persons list columns and
 * filters, the Person page, the CR diff and audit views — so the wording is the same
 * everywhere (§3h/§3j). Mirrors backend `models/person.COMMS_PREFERENCES`.
 */
export type CommsField =
  | 'comms_monthly_report' | 'comms_newsletter'
  | 'comms_event_invitations' | 'comms_commercial_offers';

export const COMMS_TYPES: { field: CommsField; label: string; short: string }[] = [
  { field: 'comms_monthly_report', label: 'Monthly report', short: 'Report' },
  { field: 'comms_newsletter', label: 'Newsletter / market commentary', short: 'News' },
  { field: 'comms_event_invitations', label: 'Event invitations', short: 'Events' },
  { field: 'comms_commercial_offers', label: 'Commercial offers', short: 'Offers' },
];

export const COMMS_LABEL: Record<string, string> = Object.fromEntries(
  COMMS_TYPES.map((t) => [t.field, t.label]),
);

export const isCommsField = (name: string | undefined): name is CommsField =>
  !!name && name in COMMS_LABEL;

/** How a stored flag reads to a person (CR diffs, audit history, confirm dialogs). */
export const commsValueLabel = (v: boolean): string => (v ? 'Receives' : 'Does not receive');

/** Column filter options: receives / doesn't (both = everyone). */
export const COMMS_FILTER_OPTIONS = [
  { value: 'true', label: 'Receives' },
  { value: 'false', label: 'Does not receive' },
];
